/**
 * model UserCommand {
  id          String   @id @default(cuid())
  name        String   @unique
  description String? // Optional short description for UI
  code        String // The Lua code
  eventType   String // e.g., "RedeemEvent", "FollowEvent", "MessageEvent", etc.
  schedule    String? // Only used for recurring commands (e.g., a CRON string or special JSON schedule)
  priority    Int      @default(0)
  createdAt   DateTime @default(now())
  updatedAt   DateTime @updatedAt
  enabled     Boolean  @default(true)
  lastRunAt   DateTime? // Null if never run yet
}

 */

/**
 * @typedef {Object} Command
 * @property {string=} id
 * @property {string=} name
 * @property {string=} description
 * @property {string=} code
 * @property {string=} eventType
 * @property {string=} schedule
 * @property {number=} priority
 * @property {string=} createdAt
 * @property {string=} updatedAt
 * @property {string=} lastRunAt
 * @property {string=} commandGroupId
 * @property {boolean=} enabled
 */

/**
 * @typedef {Object} CommandGroup
 * @property {string=} id
 * @property {string=} name
 */

/**
 * @typedef {Object} CommandService
 * @property {function(?string): angular.IPromise<Command[]|Command>} get
 * @property {function(string): angular.IPromise<Command>} delete
 * @property {function(Command): angular.IPromise<Command>} post
 * @property {function(string, Command): angular.IPromise<Command>} patch
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {CommandService}
 */
function bahabotCommandFactory($resource, $q) {
    const CommandsAll = $resource('/api/protected/commands', {}, {
        get: { method: 'GET' },
        post: { method: 'POST' }
    });

    const Commands = $resource('/api/protected/commands/:id', {
        'id': '@id'
    }, {
        get: { method: 'GET' },
        patch: { method: 'PATCH' },
    });

    return {
        get: function (id = "") {
            if (id === "") {
                return CommandsAll.get().$promise.then(res => res.data);
            }
            return Commands.get({ id }).$promise.then(res => res.data);
        },
        delete: function (id) {
            return Commands.delete({ id }).$promise.then(res => res.data)
        },
        patch: function (id, command) {
            return Commands.patch({ id }, command).$promise.then(res => res.data)
        },
        post: function (command) {
            return CommandsAll.post(command).$promise.then(res => res.data)
        }
    };
}

mod.factory('CommandService', ["$resource", bahabotCommandFactory]);
